import React from "react";
import { CitationAnchor, type CanCite } from "./CitationAnchor";
import type { CitationGroup } from "./types";

export type { CanCite } from "./CitationAnchor";

/** Interleave clean prose with tooltip-backed citation spans. */
export function renderCitedSegments(
  cleanText: string,
  groups: CitationGroup[],
  onCite: ((group: CitationGroup) => void) | undefined,
  keyBase: string,
  canCite?: CanCite,
): React.ReactNode[] {
  const sorted = [...groups].sort((a, b) => a.anchorStart - b.anchorStart);
  const nodes: React.ReactNode[] = [];
  let cursor = 0;

  sorted.forEach((group, index) => {
    const start = Math.min(
      cleanText.length,
      Math.max(cursor, group.anchorStart),
    );
    const end = Math.min(
      cleanText.length,
      Math.max(start, group.anchorEnd),
    );
    if (start > cursor) nodes.push(cleanText.slice(cursor, start));
    const anchorText = cleanText.slice(start, end) || "\u2197";

    nodes.push(
      <CitationAnchor
        key={`${keyBase}-citation-${index}`}
        group={group}
        onCite={onCite}
        canCite={canCite}
      >
        {anchorText}
      </CitationAnchor>,
    );
    cursor = end;
  });

  if (cursor < cleanText.length) nodes.push(cleanText.slice(cursor));
  return nodes;
}
